module.exports = __webpack_public_path__ + "01_bob_gold.f9a26b68.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_bob_gold.png
// module id = RfD5
// module chunks = 0